<template>
    <div class="card border-success shadow-none mb-3">
        <div class="card-body">
            <div class="row align-items-center">
                <div class="col-auto">
                    <i class="far fa-file-pdf text-danger icone-pdf" aria-hidden="true"></i>
                </div>
                <div class="col">
                    <div class="font-weight-bold text-truncate" :title="anexo.name_file">
                        @{{ anexo.name_file }}
                    </div>
                    <div class="text-muted font-size-08">
                        <span class="badge badge-success mr-2">PDF</span>
                        <span v-if="tamanhoFormatado" class="mr-2">@{{ tamanhoFormatado }}</span>
                        <span v-if="dataFormatada">Enviado em @{{ dataFormatada }}</span>
                    </div>
                </div>
                <div class="col-auto">
                    <a :href="anexo.download"
                       target="_blank"
                       rel="noopener"
                       class="btn btn-sm btn-outline-primary mr-1"
                       :aria-label="'Download de ' + anexo.name_file"
                       title="Download"
                    >
                        <i class="fas fa-download" aria-hidden="true"></i>
                        <span class="d-none d-md-inline ml-1">Download</span>
                    </a>
                    <button type="button"
                            class="btn btn-sm btn-outline-secondary mr-1"
                            aria-label="Substituir lista"
                            title="Substituir lista"
                            v-on:click="substituir()"
                    >
                        <i class="fas fa-sync-alt" aria-hidden="true"></i>
                        <span class="d-none d-md-inline ml-1">Substituir</span>
                    </button>
                    <button type="button"
                            :id="'btn-remover-' + refresh_emit"
                            class="btn btn-sm btn-outline-danger"
                            aria-label="Remover lista"
                            title="Remover lista"
                            v-on:click="remover()"
                    >
                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                        <span class="d-none d-md-inline ml-1">Remover</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {bus} from '../../app';

    export default {
        props: {
            anexo: {type: Object, required: true},
            url_delete: {type: String, required: true},
            modal_substituir_id: {type: String, required: true},
            refresh_emit: {type: String, required: true},
        },
        computed: {
            tamanhoFormatado() {
                let size = parseInt(this.anexo.file_size);
                if (!size || isNaN(size)) return null;
                if (size < 1024) return size + ' B';
                if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
                return (size / 1024 / 1024).toFixed(1) + ' MB';
            },
            dataFormatada() {
                if (!this.anexo.data_criacao) return null;
                let d = new Date(this.anexo.data_criacao.replace(' ', 'T'));
                if (isNaN(d.getTime())) return this.anexo.data_criacao;
                return d.toLocaleDateString('pt-BR') + ' às ' + d.toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'});
            },
        },
        methods: {
            substituir() {
                bus.$emit('show_modal-' + this.modal_substituir_id);
            },
            remover() {
                bus.$emit('gerencia-request', {
                    confirm_alert: {
                        content: 'Deseja remover a lista anexada? Após remover, a tabela paginada voltará a ser exibida.',
                        class: 'border-danger',
                        btn: 'btn btn-sm btn-block btn-danger',
                    },
                    url: this.url_delete,
                    method: 'DELETE',
                    data: {},
                    bus_emit: [this.refresh_emit],
                    loading: ['add_spin'],
                    id_loading: 'btn-remover-' + this.refresh_emit,
                });
            },
        },
    }
</script>

<style scoped>
.icone-pdf {
    font-size: 2.5rem;
}
</style>
